import Router from 'vue-router'

import calculationRouter from '../components/calculation/router';
import locatorRouter from '../components/locator/router';
import careerRouter from '../components/career/router';
import downloadRouter from '../components/download/router';
import ssvRouter from '../components/ssv/router';
import cadRouter from '../components/cad/router';
import reconstructionChallenge from '../components/reconstruction-challenge/router';
import trophyChallenge from '../components/trophy-challenge/router';
import contactRouter from '../components/contact/router';
import ssvOrderRouter from '../components/ssv-order/router';

const router = new Router({
    mode: 'history',
    scrollBehavior() {
        return {x: 0, y: 0};
    },
    routes: [
        calculationRouter,
        locatorRouter,
        careerRouter,
        downloadRouter,
        ssvRouter,
        ssvOrderRouter,
        cadRouter,
        reconstructionChallenge,
        trophyChallenge,
        contactRouter,
    ]
});

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js